import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/orgs/$orgId/groups')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Groups',
  }),
})

function RouteComponent() {
  return <Outlet />
}
